import { ROUTE } from "../../../routes";
export const confirmPan = async (action, _datastore, { asyncStorage, goBack, setDatastore, navigate, ...props }) => {
    // const user: User = await SharedPropsService.getUser();
    // user.linkedBorrowerAccounts[0].accountHolderPAN = action.payload.panNumber;
    // await SharedPropsService.setUser(user);
    // await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, action.payload.widgetId, <
    //   ListItemProps
    // >{
    //   subTitle: user.linkedBorrowerAccounts[0].accountHolderPAN,
    // });
    // const routeObj = await nextStepId(action.payload.currentStepId);
    // await navigate(ROUTE.DIST_BANK_SELECT, {
    //   bankCode:"",
    //   bankName:""
    // });
    await navigate(ROUTE.DIST_BANK_ACCOUNT_ADD);
    // await goBack();
    // await navigate(routeObj.routeId, routeObj.params);
};
export const changePanNo = async (action, _datastore, { goBack }) => {
    goBack();
};
